import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import LazyLoadImage from "../../../LazyLoadImage/LazyLoadImage";
import ListingSwiperPhotos from "../../ListingSwiperPhotos/ListingSwiperPhotos";

import { isRTL } from "../../../../helpers/formatLocale";
import { formatURL } from "../../../../helpers/formatURL";

import mediumNoImage from '/public/SiteImages/medium_no_image.png';
import largeNoImage from '/public/SiteImages/large_no_image.jpeg';

const CommonListingPhotos = (props) => {
  const {
    className,
    placeholderClassName,
    photoType,
    lazyLoad,
    bgImage,
    isListingSwiper,
    locale,
    coverPhoto,
    listPhotos = [],
    title,
    id,
    updatedLocale,
    children,
  } = props;

  const [activePhoto, setActivePhoto] = useState(null);

  const getImageSource = (photo, size = 'x_medium_') => {
    if (photo?.source === 'UploadCare') {
      return `https://ucarecdn.com/${photo?.name}/-/format/auto/-/scale_crop/1440x960/smart/`;
    } else {
      return `/images/upload/${size}${photo?.name}`;
    }
  };

  useEffect(() => {
    if (listPhotos?.length > 0) {
      let photo = listPhotos[0];
      if (coverPhoto) {
        const cover = listPhotos.find((item) => item.id === coverPhoto);
        if (cover) photo = cover;
      }
      setActivePhoto(photo);
    }
  }, [JSON.stringify(listPhotos), coverPhoto]); // Ensures update when list changes

  let source;

  if (activePhoto) {
    source = getImageSource(activePhoto, photoType ? 'x_medium_' : '');
  } else if (listPhotos.length > 0) {
    let photo = listPhotos[0];
    if (coverPhoto) {
      const cover = listPhotos.find((item) => item.id === coverPhoto);
      if (cover) photo = cover;
    }
    source = getImageSource(photo, photoType ? 'x_medium_' : '');
  } else {
    if (photoType === "x_medium") source = largeNoImage;
    else if (photoType === "x_small") source = mediumNoImage;
    else source = mediumNoImage;
  }

  let activeItem = 0;
  const photosList = listPhotos.slice();

  if (listPhotos.length > 1) {
    listPhotos.forEach((x, y) => {
      if (x.id === coverPhoto) activeItem = y;
    });
    if (activeItem > 0) {
      const temp = photosList[0];
      photosList[0] = photosList[activeItem];
      photosList[activeItem] = temp;
    }
  }

  const link = `/rooms/${formatURL(title)}-${id}`;

  if (isListingSwiper) {
    return (
      <ListingSwiperPhotos
        id={id}
        coverPhoto={coverPhoto}
        listPhotos={photosList}
        title={title}
        rtl={isRTL(locale)}
        updatedLocale={updatedLocale}
      />
    );
  } else if (lazyLoad && bgImage) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <LazyLoadImage
          src={source}
          placeholderSrc={activePhoto?.source === 'UploadCare' ? source : `/images/upload/placeholder_${activePhoto?.name || listPhotos[0]?.name}`}
          className={className}
          placeholderClassName={placeholderClassName}
        />
      </a>
    );
  } else if (bgImage) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className={className} style={{ backgroundImage: `url(${source})` }}>
          {children}
        </div>
      </a>
    );
  } else {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className={className} style={{ backgroundImage: `url(${source})` }} />
      </a>
    );
  }
};

const mapState = (state) => ({
  locale: state.intl.locale,
  updatedLocale: state?.intl?.newLocale,
});

export default connect(mapState)(CommonListingPhotos);
